import React, {Component} from 'react';
import {connect} from "react-redux";
import {addTranslations} from "../actions/TranslationActions";
import {bindActionCreators} from "redux";
import OneWayMatrix from "./pricesCalendar/OneWayMatrix";
import RoundTripMatrix from "./pricesCalendar/RoundTripMatrix";
import IframeHelper from "../helpers/IframeHelper";
import Translator from "../helpers/Translator";
import {matrixLoaded, selectMatrix, setMatrices, toggleMatrixCollapse} from "../actions/MatrixActions";
import {DOMAIN} from "./PricesCalendarContainer";
import Loader from "../helpers/Loader";

class PricesCalendar extends Component {

    componentDidMount() {
        let translations = {};
        translations[DOMAIN] = JSON.parse(this.props.dataTranslations);
        this.props.addTranslations(translations);
        this.props.setMatrices(JSON.parse(this.props.matrix));
        this.props.selectMatrix(this.props.parameters['search-params'].departureCity);
    }

    componentDidUpdate() {
        IframeHelper.updateHeight(this.props.parameters.projectUrl);
    }

    renderSuitableCityOption(key, value) {
        return <option key={key} value={key}>{value}</option>;
    }

    renderSuitableCitiesOptions() {
        let list = [];
        const route = JSON.parse(this.props.parameters.route);

        list.push(this.renderSuitableCityOption(this.props.parameters['search-params'].departureCity, route.from.general));

        Object.values(JSON.parse(this.props.suitableCities)).map((element) => list.push(this.renderSuitableCityOption(element.cityTo, element.translation)));

        return list;
    }

    selectSuitableCity(e) {
        this.props.selectMatrix(e.target.value);
    }

    renderCitySelect() {
        if (JSON.parse(this.props.suitableCities).length === 0) {
            const route = JSON.parse(this.props.parameters.route);

            return <div>{route.from.general}</div>;
        }

        return (
            <select onChange={this.selectSuitableCity.bind(this)} defaultValue={this.props.parameters['search-params'].departureCity} className="custom-select form-control form-control-sm">
                {this.renderSuitableCitiesOptions()}
            </select>
        );
    }

    renderSuitableCities() {
        return (
            <form
              className="form-inline float-right"
              onClick={(event) => event.stopPropagation()}
            >
                <label className="mr-sm-2 text-muted">{this.translator.trans('Departure')}</label>
                {this.renderCitySelect()}
            </form>
        );
    }

    toggleMatrix = () => {
        this.props.toggleMatrixCollapse();
        setTimeout(() => {
            IframeHelper.updateHeight(this.props.parameters.projectUrl);
        }, 0);
    };

    render() {
        if (Loader.showLoader(this.props.flights)) {
            return null;
        }

        this.translator = new Translator(this.props.translator, DOMAIN);
        let matrix = <OneWayMatrix matrix={this.props.selectedMatrix}/>;

        if (this.props.parameters['search-params'].returnDate) {
            matrix = <RoundTripMatrix matrix={this.props.selectedMatrix}/>;
        }

        if (this.props.isLoading) {
            setTimeout(() => {
                this.props.matrixLoaded();
            }, 300);
        }

        return (
            <div className={`card prices-calendar d-none d-lg-flex mb-2 ${this.props.isLoading ? 'overlay-opaque' : ''}`}>
                {this.props.isLoading && <div className="overlay"></div>}
                <div className="card-header" onClick={this.toggleMatrix}>
                    <div className="mt-1 float-left cursor-pointer">
                        <strong>{this.translator.trans('Flights prices calendar')}</strong>
                    </div>
                    <div className="calendar-legend" onClick={(event) => event.stopPropagation()}>
                        <span className="calendar-legend-item">
                            <span className="calendar-legend-dot calendar-legend-dot--cheapest"></span>
                            {this.translator.trans('Cheapest')}
                        </span>
                        <span className="calendar-legend-item">
                            <span className="calendar-legend-dot calendar-legend-dot--selected"></span>
                            {this.translator.trans('Selected')}
                        </span>
                    </div>
                    {this.renderSuitableCities()}
                </div>
                {matrix}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addTranslations,
        setMatrices,
        selectMatrix,
        matrixLoaded,
        toggleMatrixCollapse
    }, dispatch);
}

function mapStateToProps(state, ownProps) {
    return {
        dataTranslations: ownProps.translations,
        translator: state.TranslationsReducer.translations,
        flights: state.FlightsReducer,
        parameters: state.ParametersReducer.parameters,
        suitableCities: ownProps.suitableCities,
        selectedMatrix: state.MatrixReducer.selected,
        isLoading: state.MatrixReducer.loading
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PricesCalendar);



// WEBPACK FOOTER //
// ./src/components/PricesCalendar.js